import React, {FC, memo} from "react";
import {Badge, Tooltip} from "antd";
import {colorLessonBookingTertiary} from "../../styles/colors";
import css from "./RibbonBadgeEZB.less";

type RibbonBadgeEZBProps = {
    children: React.ReactNode;
    text?: string;
    tooltipTitle?: string;
    tooltipStyle?: React.CSSProperties;
    style?: React.CSSProperties;
};

const RibbonBadgeEZB: FC<RibbonBadgeEZBProps> = ({children, text, tooltipTitle, tooltipStyle, style}) => {
    const textToRender = text ?? "EZB";
    const renderContent = () => (
        <Tooltip title={tooltipTitle ?? "Einzelbuchung"} trigger="click" className={css.tooltip}>
            <span className={css.tooltipText} style={{...tooltipStyle}}>
                {textToRender}
            </span>
        </Tooltip>
    );

    return (
        <Badge.Ribbon text={renderContent()} placement="start" color={colorLessonBookingTertiary} className={css.lessonBookingBadge} style={style}>
            {children}
        </Badge.Ribbon>
    );
};

export default memo(RibbonBadgeEZB);
